export const IS_SPECIAL_USER_KEY = "isSpecialCode";

/** Persist special-user flag from verify-code or purchase API (`isSpecialCode`). */
export function persistSpecialUserFlag(isSpecialCode) {
  if (isSpecialCode === true) {
    localStorage.setItem(IS_SPECIAL_USER_KEY, "true");
  } else {
    localStorage.removeItem(IS_SPECIAL_USER_KEY);
  }
}

export function readSpecialUserFlag() {
  return localStorage.getItem(IS_SPECIAL_USER_KEY) === "true";
}

export function contractIsSpecialCodeArg(postApiRes) {
  return Boolean(postApiRes?.isSpecialCode);
}
